import { BlogType } from "@/types/global";
import Image from "next/image";
import Link from "next/link";

interface Props {
    data: BlogType;
    varient?: "style-3";
}

const BlogAreaCard = ({ data, varient }: Props) => {
    return (
        <div className={`desilo-blog-box blog-card-modern ${varient} cursor-pointer`}>
            <Link href={data.url}>
                <div className="desilo-blog-thumb">
                    {/* Main content */}
                    <div className="blog-content-wrapper">
                        {/* Category tag */}
                        <div className="blog-category-tag">
                            <span className="category-text">{data.tag}</span>
                            <div className="blog-star-icon">
                                <div className="">
                                    <Image src="/images/blog/Frame.png" alt="star" width={61} height={61} loading="lazy" />
                                </div>
                            </div>
                        </div>

                        {/* Title section */}
                        <div className="blog-title-section">
                            <h3 className="blog-main-title blog-title-ellipsis">
                                {data.title}
                            </h3>
                            <p className="blog-subtitle blog-title-ellipsis">{data.description}</p>
                        </div>
                    </div>

                    {/* Author and date */}
                    <div className="blog-author-section">
                        <div className="author-name">{data.author}</div>
                        <div className="blog-date">{data.date}</div>
                    </div>
                </div>
            </Link>
        </div>
    );
};

export default BlogAreaCard;
